import React, { useState, useEffect } from "react";
import { useUsuario } from "App/Hooks/global/UsuarioContext";
import { Theme } from "theme/Theme";
import { PanelMenu } from "primereact/panelmenu";
import styled from "styled-components";
import { useNavigate } from "react-router-dom";
import { Typography } from "core/util-styled-components";
import { useGlobal } from "App/Hooks/global/GlobalContext";

const PanelMenuStyled = styled(PanelMenu)`
  overflow: auto;
  background-color: ${Theme.colors.primary};
  min-height: calc(100vh - 110px);
  .p-panelmenu-header,
  .p-panelmenu-header-link {
    background-color: ${Theme.colors.primary} !important;
  }

  .p-panelmenu-header-link {
    color: #f6f6f6 !important;
    border: none !important;
    padding: 0.7rem 0.5rem !important;
  }
  .p-panelmenu-header-link:hover,
  .p-panelmenu-header-link:focus {
    color: #fff !important;
  }
  .p-toggleable-content,
  .p-panelmenu-content {
    background-color: black !important;
    color: #fff !important;
    border: none !important;
  }
  .p-menuitem-text,
  .p-menuitem-icon {
    color: #fff !important;
  }
  .p-menuitem {
    background-color: #000000 !important;
    padding: 0.25rem !important;
    transition: all 0.05s ease-in-out;
  }

  .p-menuitem:hover {
    border-left: 0.2rem solid ${Theme.colors.primary} !important;
  }

  .p-menuitem-link:active,
  .p-menuitem-link:focus,
  .p-panelmenu-header-link:focus {
    border: none !important;
    outline: 0 !important;
    box-shadow: none !important;
  }

  .p-panelmenu-content:hover * {
    background-color: black !important;
  }
  .p-panelmenu-icon {
    font-size: 0.6rem !important;
  }
  .p-panelmenu .p-panelmenu-header > a:focus,
  .p-panelmenu .p-panelmenu-content .p-menuitem .p-menuitem-link:focus {
    box-shadow: none !important;
  }
`;

const BarraLateral = () => {
  const { barra } = useUsuario();
  const { setBarraActiva } = useGlobal();
  const nav = useNavigate();
  const [myBar, setMyBar] = useState([]);
  const adaptedBarra = (b) =>
    b
      .filter((el) => !el.disabled)
      .map((el) => {
        if (el.submenus) {
          el.submenus = el.submenus.filter((el) => !el.disabled);
        }
        return {
          label: <Typography color="inherit">{el.label}</Typography>,
          icon: "fa fa-" + el.iconName,
          disabled: el.disabled,
          items: el.submenus && adaptedBarra(el.submenus),
          command: () => {
            if (el.link) {
              setBarraActiva(false);
              nav(el.link);
            }
          },
        };
      });
  useEffect(() => {
    if (Array.isArray(barra) && barra.length > 0) {
      setMyBar(adaptedBarra(barra));
    }

    return () => {};
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [barra]);

  return <PanelMenuStyled model={myBar} color={"primary"} />;
};

export default BarraLateral;
